class IndexBenefits extends HTMLElement {
  constructor() {
    super();
    this.initScrollAnimation();
  }

  initScrollAnimation() {
    const cards = this.querySelectorAll('.index-benefits__card');

    if (!cards.length) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const card = entry.target;
          const delay = parseInt(card.dataset.animateDelay, 10) || 0;

          setTimeout(() => {
            card.classList.add('animate-in');
          }, delay * 150);

          observer.unobserve(card);
        }
      });
    }, {
      root: null,
      rootMargin: '0px 0px -10% 0px',
      threshold: 0.1
    });

    cards.forEach((card) => {
      observer.observe(card);
    });
  }
}

customElements.define('index-benefits', IndexBenefits);
